import React from 'react';
export const Header = () => {
  return <header className="mb-4 sm:mb-6" data-id="element-217">
      <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold leading-tight" data-id="element-218">
        Busy Professionals Are Ditching Pills for This 15-Second Sleep
        Breakthrough
      </h1>
    </header>;
};